import 'slick-carousel';
import slickCss from 'slick-carousel/slick/slick.css';

const domElements = {};

function initDomElements() {
  domElements.main = $('.products__teaser-list');
  domElements.slider = domElements.main.find('.products__teaser-list__items');
}

function productTeaserList() {
  initDomElements();

  domElements.slider.slick({
    speed: 500,
    infinite: true,
    adaptiveHeight: true,
    pauseOnHover: true,
    pauseOnFocus: true,
    autoplay: false,
    autoplaySpeed: 3000,
    fade: false,
    dots: false,
    slidesToShow: 4,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      }
    ],
  });
}

export default productTeaserList;